/* eslint-disable no-console */
// SessionHandler.js
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'common/hooks/state';
import { clearCredentials, setCredentials } from 'features/login/authSlice';
import { RootState } from 'common/store/store';
import { useLocation } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';
import toast from 'react-hot-toast';
import { safeStorage } from 'common/utils/safeStorage';

export const SessionHandler = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { token, persist } = useAppSelector((state: RootState) => state.auth);
  const clearSession = () => {
    dispatch(clearCredentials());
  };
  const bypassSessionCheckPaths = ['/login', '/mfa', '/verify', '/signup', '/'];

  useEffect(() => {
    const checkToken = async () => {
      let currentToken = token;

      // If no token in Redux, check Capacitor Preferences
      const retryAttempts = 1;
      let attempts = 0;

      const retrieveTokenWithRetry = async () => {
        try {
          const { value } = await Preferences.get({ key: 'userToken' });
          if (value) {
            // Never log the bearer token value — it leaks to device logs and any
            // remote log collector. Log presence only.
            console.log('Token retrieved from Capacitor Preferences.');
            currentToken = { token: value };
            dispatch(setCredentials({ user: null, token: currentToken, persist: { isPersist: true } }));
          } else {
            console.log('No token found in Capacitor Preferences.');
            // toast.error('No token found.');
          }
        } catch (error) {
          console.error('Error retrieving token from Capacitor Preferences:', error);
          // toast.error('Error retrieving token');
        }

        attempts += 1;
        if (attempts < retryAttempts) {
          await retrieveTokenWithRetry();
        }
      };

      if (!currentToken && Capacitor.isNativePlatform()) {
        await retrieveTokenWithRetry();
      }

      const isSessionChecked = safeStorage.getItem('isSessionChecked');
      const isBypassPath = bypassSessionCheckPaths.includes(location.pathname);

      if (location.pathname === '/login' && isSessionChecked === 'false') {
        if (currentToken && persist?.isPersist === false) {
          clearSession();
        }
        safeStorage.setItem('isSessionChecked', 'true');
      }

      if (
        currentToken && persist?.isPersist === false && isSessionChecked === 'false' && !isBypassPath
      ) {
        safeStorage.setItem('isSessionChecked', 'true');
        clearSession();
      }
    };

    checkToken();
  }, [token, persist, location]);

  return null;
};

export default SessionHandler;
